import { render, staticRenderFns } from "./staticList.vue?vue&type=template&id=996ad306&"
import script from "./staticList.vue?vue&type=script&lang=js&"
export * from "./staticList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/list/staticList.vue"
export default component.exports